export default __webpack_public_path__ + "98a6927ae06b46c0e09eca6d11064c82.woff2";